import { makeStyles } from "@material-ui/styles";
import color from "context/MaterialUITheme/color";

export const useStyles = makeStyles(() => ({
  container: {
    height: "100%",
    maxWidth: "md",
    maxHeight: "100%",
    minHeight: "60vh",
    alignSelf: "center",
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    display: "flex !important",
    padding: "0 0 0 0 !important",
  },
  label: {
    color: color.black,
    marginTop: "15%",
    marginBottom: "15%",
    fontFamily: "Pro Display Semibold",
  },
}));
